<template>
  <div v-if="swiths.length>0" class="remote-control">
    <div class="title">
      <div class="parallelogram">
        <span>远程控制</span>
      </div>
      <div class="parallelogram extra-line">
        <span>线条</span>
      </div>
    </div>
    <ul>
      <li v-for="(item,index) in filterswitch" :key="index">
        <img :class="getClass(item.photo)" :src="item.src"/>
        <div class="equipment">
          <p class="equipment-name">{{item.name}}</p>
          <el-switch
            style="display: block"
            :value="item.on"
            @change="changeSwitch(item,$event,index)"
            inactive-color="rgba(93,106,118,0.4)">
          </el-switch>
        </div>
        <img src="../../../public/images/icon_editor.png" alt="" class="modify" @click="edit(item.id,index)">
        <!-- <img src="../../../public/images/bg_yuancheng.png" > -->
      </li>
    </ul>
    <dialog-box :titleName="titleName" :showDialog="showDialog" :dialogWidth="dialogWidth" @changeShow="changeShow">
      <div class="inputName">
        <span class="name">名称</span><el-input class="input-name" maxlength="10" v-model="obj.name" placeholder="请输入名称"></el-input>
      </div>
      <div>
        <span class="scopeValue">功率</span>
        <el-input class="power" v-model="obj.power" type="number" placeholder="请输入功率"></el-input>
        <el-select v-model="select" slot="prepend" placeholder="W" @change="changePower">
          <el-option v-for="(item,index) in powerOption" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <span class="upload-image">图片</span>
        <ul style="" class="clearfix upload-wrap">
          <li class="upload-button">
            <input ref="fileSelected" type="file" @change="load" />
            <img src="../../../public/images/img_add.png" alt="">
            <p>点击修改图片</p>
            <p>支持jpg/png格式</p>
            <p>不超过1M</p>
          </li>
          <!-- <el-upload class="upload-demo"
            action=""
            :before-upload="beforeAvatarUpload"
            list-type="picture-card">
            <img src="../../../public/images/img_add.png" alt="">
            <p>点击修改图片</p>
            <p>支持jpg/png格式</p>
            <p>不超过1M</p>
          </el-upload> -->
          <li class="defalut-img" :class="{active:obj.photo ==1}" @click="obj.photo =1">
            <img src="../../../public/images/icon_oxygenation.png" alt="">
          </li>
          <li class="defalut-img" :class="{active:obj.photo ==2}" @click="obj.photo =2">
            <img src="../../../public/images/icon_feeding.png" alt="">
          </li>
          <li class="defalut-img" :class="{active:obj.photo ==3}" @click="obj.photo =3">
            <img src="../../../public/images/icon_plug.png" alt="">
          </li>
          <li class="defalut-img" :class="{ active: obj.photo == 4 }" @click="obj.photo = 4">
            <img src="../../../public/images/icon_shuibeng_shebei_big.png" alt="" />
          </li>
          <li class="defalut-img" :class="{ active: obj.photo == 5 }" @click="obj.photo = 5">
            <img src="../../../public/images/icon_lighting_shebei_big.png" alt="" />
          </li>

        </ul>

      </div>
      <div>
        <el-button style="margin-left:80px;" type="primary" @click="save">保存</el-button>
      </div>

    </dialog-box>
  </div>
</template>

<script>
import DialogBox from '../common/DialogBox'
import { mapState, mapMutations, mapActions } from 'vuex'
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import indexModule from '../../store/modules/index'
import img from '../../services/img'
export default {
  name: 'RemoteControl',
  components: {
    DialogBox
  },
  data: function () {
    return {
      showDialog: false,
      titleName: '远程控制修改',
      dialogWidth: '600px',
      input: '',
      select: '',
      imgSrc: null,
      list: [],
      obj: {
        index: '',
        id: null,
        name: '',
        photo: '',
        power: null
      },
      powerOption: [
        {
          value: '1',
          label: 'W'
        },
        {
          value: '2',
          label: 'KW'
        }
      ]
    }
  },
  mounted () {
    this.select = this.powerOption[0].value
  },
  computed: {
    ...mapState(equipmentSocketModule, ['swiths']),
    ...mapState(indexModule, ['equipmentId']),
    // 设备logo图片
    filterswitch () {
      this.swiths.map(function (item) {
        if (item.photo === '1' || item.photo === 1) {
          item.src = '/images/icon_oxygenation.png'
        } else if (item.photo === '2' || item.photo === 2) {
          item.src = '/images/icon_feeding.png'
        } else if (item.photo === '3' || item.photo === 3) {
          item.src = '/images/icon_plug.png'
        } else if (item.photo === '4' || item.photo === 4) {
          item.src = '/images/icon_shuibeng_shebei_big.png'
        } else if (item.photo === '5' || item.photo === 5) {
          item.src = '/images/icon_lighting_shebei_big.png'
        } else {
          item.src = item.photo
        }
        return item
      })
      return this.swiths
    }
  },
  methods: {
    ...mapMutations(equipmentSocketModule, ['setSwitch']),
    ...mapActions(equipmentSocketModule, ['getSwithEditView', 'updateSwith', 'remoteCtrl']),
    changeSwitch (swith, e, num) {
      // 远程控制开关
      this.remoteCtrl({ rtuId: this.equipmentId,
        indexCtrl: num,
        switchEnum: !swith.on ? 1 : 0 })
        .then(data => {
          this.setSwitch({
            item: swith,
            value: e
          })
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
    },
    getClass (value) {
      if (value === '1') {
        return 'img1'
      } else if (value === '2') {
        return 'img2'
      } else if (value === '3') {
        return 'img3'
      } else if (value === '4') {
        return 'img4'
      } else if (value === '5') {
        return 'img5'
      } else {
        return 'img'
      }
    },
    async load (e) {
      let filePath = e.target.files[0]
      let dataUrl = await img.getFileDataUrl(filePath)
      this.imgSrc = await img.getImgBase64(dataUrl, 80, 80)
    },
    changePower (e) {
      if (this.select === '2') {
        this.obj.power = this.obj.power / 1000
      } else {
        this.obj.power = this.obj.power * 1000
      }
    },
    save () {
      if (this.imgSrc && this.obj.photo === this.imgSrc) {
        this.obj.photo = this.imgSrc
      }
      if (this.select === '2') {
        var power = this.obj.power * 1000
      } else {
        power = this.obj.power
      }
      this.updateSwith({

        data: {
          id: this.obj.id,
          index: this.obj.index,
          photo: this.obj.photo,
          name: this.obj.name,
          power: power
        }
      }).then(async (data) => {
        this.$Alert.info({
          content: '保存成功',
          duration: 1000,
          status: 'success'
        })
        this.showDialog = false
      }).catch(err => {
        console.log(err)
        this.$Alert.info({
          content: '保存失败',
          duration: 1000,
          status: 'error'
        })
      })
    },
    async edit (id, index) {
      this.obj = {}
      this.imgSrc = ''
      this.select = this.powerOption[0].value
      this.showDialog = true
      let result = await this.getSwithEditView(id)
      this.obj = result
      this.imgSrc = this.obj.photo.length > 1 ? this.obj.photo : null
      this.obj.index = index
    },
    // 弹窗
    changeShow () {
      this.showDialog = false
    }
  }
}
</script>

<style lang="stylus">
.el-switch.is-checked .el-switch__core {
    border-color: #409EFF !important;
    background-color: #409EFF !important;
    background:linear-gradient(0deg,rgba(40,124,255,1),rgba(71,241,255,1));
}
.el-switch {
    text-align: left;
    margin-left: 3px;
}
.el-upload--picture-card
  float: left;
  width: 120px;
  height: 120px;
  margin-right:10px;
  margin-bottom:10px
  padding: 10px 0;
  line-height: normal;
  border: 1px solid #07f;
  background: none;
.upload-button
  position relative
  padding-top:5px
  input {
    position: absolute;

    opacity: 0;
    width: 130px;
    left: 0;
    height: 130px;
  }

.upload-wrap
  display:inline-block;
  margin-left:80px;
  margin-top:-20px
  // .upload-button
  //   border:1px solid #040c17;
  li
    width:130px;
    height:130px;
    float:left;
    text-align center
    margin-right:10px;
    margin-bottom:10px
    border:1px solid #07f;
    border-radius:4px;
    color:#6E8094
    background #203051

    img
      margin 5px 0
// .el-dialog__body
//   .input-name
//     border:1px solid #040c17
  // .el-input__inner
//     border:1px solid #0077FF
</style>

<style lang="stylus" scoped>
.remote-control {
  margin-bottom: 20px;

  .title {
    position relative
    margin: 0 0 0 20px;
    border-bottom: 1px solid #0151C7;

    .parallelogram {
      text-align: center;

      span {
        transform: skew(15deg);
        line-height: 44px;
        font-size: 16px;
        color: #BBD4E9;
      }
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 38px 0 14px;
  }

  li {
    position relative
    display: flex;
    flex: 1 50% 0;
    flex-direction: row;
    width: 286px;
    height 114px;
    margin-bottom: 20px;
    margin-left: 10px;
    padding: 15px;
    text-align: center;
    // background: rgba(255, 255, 255, 0.1);
    background: url('../../../public/images/bg_yuancheng.png') no-repeat;
    background-size:100% 100%;
    // border-radius: 10px;

    .equipment {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 25px;
      left: 123px;
      text-align :left;
      .equipment-name {
        width 110px;
        text-overflow:ellipsis;
        white-space:nowrap;
        overflow:hidden;
        margin-bottom: 15px;
        font-size 18px;
        color: #fff;
      }
    }

    img {
      margin-right 15px;
    }
    .img {
      height: 62px;
      width: 62px;
      margin-top: 10px;
      margin-left: 8px;
    }
    .img1{
      width: 79px;
      height: 79px;
      margin-top: 1px;
    }
    .img2{
      height: 60px;
      width: 70px;
      margin-top: 10px;
      margin-left: 5px;
    }
    .img3{
      height: 62px;
      width: 62px;
      margin-top: 10px;
      margin-left: 8px;
    }
    .img4{
      height: 58px;
      width: 82px;
      margin-top: 10px;
      margin-left: 0.3px;
    }
    .img5{
      height: 73px;
      width: 50px;
      margin-top: 6px;
      margin-left: 16.5px;
    }

    >div {
      p {
        color: white;
      }
    }
  }
  .upload-image {
    color white
  }

  .modify {
    position absolute
    top 10px
    right 0px
    height: 16px;
    width 16px
    margin-left: 10px;
    color: #00a2ff;
    cursor: pointer;
  }
}

.power {
  width: 200px;
  margin-right: 20px;
}
.defalut-img{
  line-height:126px;
}
    .active{
      border:2px solid #49C9FF
    }
</style>
